import ReactDOM from 'react-dom';

const Portal = ({ children, element }: any) => ReactDOM.createPortal(children, element);

export default Portal;
